export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_INDEX_INPUT = 1;
export const COUNT_UNREAD_NOTIFICATION_INTERVAL = 30000;
export const DEFAULT_SUCCESS_TITLE = "Success!";
export const DEFAULT_ERROR_TITLE = "Error!";
export const CREATE_SUCCESS_MESSAGE = "Create success";
export const UPDATE_SUCCESS_MESSAGE = "Update success";
export const DELETE_SUCCESS_MESSAGE = "Delete success";
export const CLONE_SUCCESS_MESSAGE = "Clone success";

export const REACT_APP_API_BASE_URL_LOGIN =
  process.env.REACT_APP_API_BASE_URL_LOGIN ??
  "https://gw-dev.talentnet.vn/api/v1";
export const BYPASS_AZURE = process.env.BYPASS_AZURE ?? 0;

export const REACT_APP_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? "http://192.168.11.112:4002";
export const REACT_APP_API_URL_REPORT =
  process.env.REACT_APP_API_URL_REPORT ?? "https://api-trpm.vgroup.com.vn";

export const VALIDATE_PASSWORD_MIN = 8;
export const REACT_APP_APPLICATION_CODE =
  process.env.REACT_APP_APPLICATION_CODE ?? "TCP";

export const REACT_APP_API_URL_E_CONTRACT =
  process.env.REACT_APP_API_URL_E_CONTRACT ?? "http://192.168.1.35:4000";
